export default __webpack_public_path__ + "static/media/GLI.9c2314e4.png";